import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonProdotti = () => {
    return (
        <SkeletonTheme baseColor="#1A1F2B" highlightColor="#2A2F3A">
            {[...Array(3)].map((_, i) => (
                <div key={i} className="w-full px-4 py-3">
                        <div className="relative bg-surface border border-accent rounded-3xl shadow-lg px-6 py-6 flex flex-col gap-3 max-w-md mx-auto items-center text-center space-y-4">

                            {/* 🔘 Immagine */}
                            <div className="w-24 h-24 rounded-full overflow-hidden">
                                <Skeleton circle width="100%" height="100%" />
                            </div>

                            {/* 📋 Titolo */}
                            <Skeleton width={120} height={20} />

                            {/* 🍕 Ingredienti */}
                            <Skeleton width={180} height={14} />
                            <Skeleton width={150} height={14} />

                            {/* 💶 Prezzo */}
                            <div className="px-3 py-1 rounded-full border border-accent">
                                <Skeleton width={60} height={16} />
                            </div>
                        </div>
                    </div>
            ))}
        </SkeletonTheme>
    );
};

export default SkeletonProdotti;